<script setup>
import Chat from '@/views/apps/chat/Chat.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'chat',
    layoutWrapperClasses: 'layout-content-height-fixed',
  },
})
</script>

<template>
  <Chat/>
</template>

